export default __webpack_public_path__ + "static/media/white-full1.3eb4af57.png";